import React from "react";
import { Div } from "components/Base";

const SubissionLimitReached = ({}) => {
  return (
    <Div
      bg="warning2"
      bra={2}
      p={3}
      mb={3}
      display="row.center.center"
      tabIndex={0}
      fw={3}
      color="#494949"
    >
      You have reached the submission limit.
    </Div>
  );
};

export default SubissionLimitReached;
